import { createAsyncThunk } from "@reduxjs/toolkit";
import { IDeleteApiResponse } from "../../utils/api.types";
import axios from "../../utils/axios";

import {
    ICustomerDetails,
    ICustomersList,
    CustomerFetch,
    IAdjustOpeningBalancePayload,
    IOpeningBalanceAdjustmentResponse,
    IOpeningBalanceHistoryResponse
} from "../../utils/customer.types";

/**
 * Fetch Customers async thunk.
*/
export const fetchCustomers = createAsyncThunk(
    'account/fetchCustomers',
    async (accountId: string): Promise<ICustomersList> => {
        const response = await axios.get(`api/v1/customers/${accountId}`);

        return response.data.customers;
    }
);

export const fetchCustomersWithFilters = createAsyncThunk(
    'account/fetchCustomersWithFilters',
    async ({accountId, params} : CustomerFetch): Promise<ICustomersList> => {
        console.log("params == ", params);
        let queryParam = (params) ? `${params}`: ''
        const response = await axios.get(`/api/v1/customers/${accountId}/search?${queryParam}`);

        return response.data;
    }
);

/**
 * Fetch Customer by user id async thunk.
*/
export const fetchCustomersById = createAsyncThunk(
    'account/fetchCustomersById',
    async (id: string): Promise<ICustomerDetails> => {
        const response = await axios.get(`api/v1/customers/single/${id}`);
        return response.data;
    }
);

/**
 * Update Customer Agreed Services async thunk.
*/
export const updateServicesCustomerById = createAsyncThunk(
    'account/updateServicesCustomerById',
    async (updatePayload: any): Promise<ICustomerDetails> => {
        const response = await axios.put(`api/v1/customers/single/update-agreed-services`, updatePayload);
        return response.data;
    }
);

/**
 * Adjust Party Opening Balance async thunk.
 *
 * Allows users to increase or decrease party opening balance
 * Creates proper journal entries and maintains accounting integrity
*/
export const adjustPartyOpeningBalance = createAsyncThunk(
    'customer/adjustPartyOpeningBalance',
    async ({ partyId, adjustment }: IAdjustOpeningBalancePayload): Promise<IOpeningBalanceAdjustmentResponse> => {
        const response = await axios.post(`/api/v1/customers/${partyId}/opening-balance/adjust`, adjustment);
        return response.data;
    }
);

/**
 * Fetch Party Opening Balance History async thunk.
 *
 * Fetches all historical records of opening balance adjustments
 * Including manual adjustments and year-end closing entries
*/
export const fetchPartyOpeningBalanceHistory = createAsyncThunk(
    'customer/fetchPartyOpeningBalanceHistory',
    async (partyId: string): Promise<IOpeningBalanceHistoryResponse> => {
        const response = await axios.get(`/api/v1/customers/${partyId}/opening-balance/history`);
        return response.data;
    }
);




